/** Query param for cupcake-only order flow (step 1, cupcakes pre-selected on step 2). */
export const CUPCAKE_PRODUCT_QUERY = 'product=cupcakes';
export const STANDARD_CAKE_PRODUCT_QUERY = 'product=cakes';

export const CUPCAKE_ORDER_PATH = `/order?step=1&${CUPCAKE_PRODUCT_QUERY}`;
export const STANDARD_CAKE_ORDER_PATH = `/order?step=1&${STANDARD_CAKE_PRODUCT_QUERY}`;

export function isCupcakeProductPreset(searchParams) {
  const product = (searchParams.get('product') || '').toLowerCase();
  return product === 'cupcakes' || product === 'cupcake';
}

export const CUPCAKE_FORM_PRESET = {
  cakeShape: 'Cupcakes',
  cakeSize: 'Cupcakes',
};
